function buildRequestUrl() {
  const _this = $('frame-variant-picker');
  if ($(_this).length == 0) { return }
  const section_id = $(_this).parents('.shopify-section').attr('id').replace('shopify-section-', '');
  const selectedOption = $('frame-variant-picker input:checked'); // Get the checked input
  const optionValueId = selectedOption.data('option-value-id'); // Get its data-option-value-id

  if (!optionValueId) {
    return; // If no option value ID is found, return nothing
  }

  const productUrl = $(_this).data('product-url');

  return `${productUrl}?section_id=${section_id}&option_values=${optionValueId}&view=frame`;
}
const i = v => parseInt((v || '').toString().replace(/[^\d\-]/g, ''), 10) || 0;
const off = (p, c) => (c > 0 && p > 0 && p < c) ? Math.round((1 - p / c) * 100) : 0;
const norm = s => (s || '').toString().toLowerCase().replace(/\s+/g, '');
function alreadyCheckedFrame() {
  $(`.mrk-frame-switcher input[frame-color="${window.selected_frame}"]`).prop('checked', true).trigger('change');
  setTimeout(function () {
    if ($('.mrk-frame-switcher input:checked').attr('frame-color') != window.selected_frame) {
      $(`.mrk-frame-switcher input[frame-color="${window.selected_frame}"]`).prop('checked', true).trigger('change');
    }
  }, 100)
}
function updateFrames(selectedOption) {
  $('.mrk-size-selector-wrapper details').prop('open', false);
  $('frame-variant-picker input').each(function () {
    if ($(this).val() === selectedOption) {
      $(this).prop('checked', true);
    }
  });
  if ($(`frame-variant-picker input[value='${selectedOption}']`).length == 0) {
    return;
  }
  window.selected_frame = $('.mrk-frame-switcher input:checked').attr('frame-color');
  var url = buildRequestUrl();
  $.get(url, function (response) {
    var variantPickerHtml = $(response).find('frame-variant-picker').html();
    $('frame-variant-picker').html(variantPickerHtml);
    alreadyCheckedFrame();
  });
}
// find frame variant by size text + color (falls back to color-only)
function findFrameVariant(sizeText, color) {
  const sizeN = norm(sizeText), colorN = norm(color);
  const list = Array.isArray(window.mrkFrameData) ? window.mrkFrameData : [];
  for (const v of list) {
    const opts = Array.isArray(v.options) && v.options.length ? v.options
      : [v.option1, v.option2, v.option3].filter(Boolean);
    const hasColor = opts.some(o => norm(o) === colorN);
    const hasSize = sizeN ? opts.some(o => norm(o).includes(sizeN) || sizeN.includes(norm(o))) : false;
    if ((hasColor && hasSize) || (hasColor && !sizeN)) return {
      id: v.id, price: i(v.price || v.price_cents), compare: i(v.compare_at_price || v.compare_at_price_cents)
    };
  }
  return null;
}

function mrkUpdateFrameTotal() {

  $('.mrk-child-frame-item').each(function () {
    var totalPrice = 0;
    var totalCompare = 0;
    qty = 1;
    var color = ($(this).find('input').first().val() || '').trim();
    // size from selected option's title attribute
    $('.mrk-variant-option option:selected').each(function () {
      var sizeText = ($(this).attr('title') || '').trim();
      var v = findFrameVariant(sizeText, color);
      if (!v) return;

      totalPrice += (v.price * qty);
      totalCompare += (v.compare * qty);
    });
    $(this).find('.mrk-frame-price').html(Shopify.formatMoney(totalPrice));

    if (totalCompare > totalPrice) {
      $(this).find('.mrk-frame-compare-price').html(Shopify.formatMoney(totalCompare)).show();
    } else {
      $(this).find('.mrk-frame-compare-price').empty().hide();
    }
  });
}

$(document).on('mrkVariantChanged', function (e) {
  alreadyCheckedFrame();
});
(function ($) {
  function updateItem($it) {
    // helpers
    const n = (v) => {
      if (v == null) return 0;
      const s = String(v).replace(/[^\d.-]/g, '');
      const num = parseFloat(s);
      return isNaN(num) ? 0 : num;
    };

    // selects within this item
    const $sizeSel = $it.find('.mrk-variant-option').eq(0);
    const child = $('[name="framing-service"]').is(':checked');
    const _size = $it.find('.mrk-option-option').val();
    const $frame = $('.mrk-frame-switcher input:checked');
    let mrk_main_variant = null;

    if (child) {
      $sizeSel.find('option').each(function () {
        if ($(this).attr('title') == _size) {
          if (child) {
            $(this).prop('selected', true);
          }
          return false;
        }
      })
    }
    $sizeSel.find('option').each(function () {
      if ($(this).attr('title') == _size && $(this).attr('frame').toLowerCase().includes($frame.val().toLowerCase())) {
        if (!child)
          $(this).prop('selected', true);
        mrk_main_variant = $(this).val();
        return false;
      }
    })
    const $opt = $sizeSel.find(':selected');
    // main variant info (from <option> attrs)
    const main_variant = {
      id: $sizeSel.val(),
      price: n($opt.attr('price')),
      compare_price: n($opt.attr('compare-price')),
      title: ($opt.attr('title') || '').trim()
    };
    // derive size from title "(...)" or fall back to full text
    const size = ((main_variant.title.match(/\(([^)]+)\)/) || [])[1] || main_variant.title || '').trim();

    // frame selection (scoped to this item)
    const frame_val = $frame.val();
    const frame_variant = findFrameVariant(size, frame_val); //$frame.data('variantId');
    // console.log(frame_variant, 'frame variant');
    const frame_price = n(frame_variant?.price || 0);
    const frame_compare_price = n(frame_variant?.compare || 0);
    const is_unframed = !frame_variant;

    // framing service (checkbox + its variant/prices)
    const $fs = $('[name="framing-service"]');
    const framing_service = !$fs.is(':checked'); // keep same semantics as reference
    const framing_service_variant = $fs.val();
    const framing_service_price = n($fs.data('price'));
    const framing_service_compare_price = n($fs.data('comparePrice'));

    // collections we’ll save on the element
    const variants = [];
    const prices = [];
    let mrk_sku = '';

    // toggle frame images (scoped)
    $it.find('.mrk-frame-image-item').hide();
    let frame_system_id = '';

    if (!is_unframed) {
      // push frame variant + price
      if (child) {
        variants.push({ id: frame_variant.id, parent_id: main_variant.id });
        prices.push({ price: frame_price, compare_price: frame_compare_price });
      }
      // show matching frame image and capture system id
      const colorKey = (frame_val || '').toLowerCase();
      const $img = $it.find(`.mrk-frame-image-item[color="${colorKey}"]`);
      if ($img.length) {
        $img.show();
        frame_system_id = $img.attr('data-frame-id') || '';
      }

      // base SKU for framed/unframed
      mrk_sku = `${size}-${(frame_val || '').toString().toUpperCase()}-FRAME`;

      // optional framing service
      if (framing_service && framing_service_variant) {
        variants.push({ id: framing_service_variant, parent_id: main_variant.id });
        prices.push({ price: framing_service_price, compare_price: framing_service_compare_price });
        mrk_sku = `${size}-FRAMED-${(frame_val || '').toString().toUpperCase()}`;
      }

      // enable & set frame id input, show service UI
      $it.find('.mrk-frame-id').val(frame_system_id).prop('disabled', false);
      $('.mrk-framing-service-wrapper').show();
    } else {
      // unframed: hide service UI, disable frame id input
      $('.mrk-framing-service-wrapper').hide();
      $it.find('.mrk-frame-id').prop('disabled', true);
    }

    // compute totals (main + any added components)
    const addedPrice = prices.reduce((s, p) => s + n(p.price), 0);
    const addedCompare = prices.reduce((s, p) => s + n(p.compare_price), 0);
    // console.log(prices, main_variant, 'prices main-variant');
    const total_price = n(main_variant.price) + addedPrice;
    const total_compare = n(main_variant.compare_price) + addedCompare;
    // persist on the element for later use
    $it
      .attr({
        'data-main-id': main_variant.id || '',
        'data-frame-id': frame_variant || '',
        'data-framing-service-id': !is_unframed && framing_service && framing_service_variant ? framing_service_variant : '',
        'data-main-variant': mrk_main_variant ? mrk_main_variant : '',
        'data-frame-system-id': frame_system_id || '',
        'data-price': total_price,
        'data-compare': total_compare,
        'data-sku': mrk_sku
      })
      // also stash structured data
      .data('variants', variants)
      .data('prices', prices)
      .data('mrk_sku', mrk_sku)
      .data('is_unframed', !!is_unframed);
  }


  function rebuild(){
    const $inputsBox = $('.mrk-hidden-inputs'); // target container
    let inputs = '';
    let idx = 0;            // global index across all items
    let total = 0;
    let tComp = 0;

    const n = (v) => {
      if (v == null) return 0;
      const s = String(v).replace(/[^\d.-]/g, '');
      const x = parseFloat(s);
      return isNaN(x) ? 0 : x;
    };

    $('.mrk-gallery-wall-item').each(function () {
      const $it = $(this);

      // ensure the item is hydrated by updateItem
      if (!$it.attr('data-main-id')) updateItem($it);

      const mainId = $it.attr('data-main-id') || '';
      if (!mainId) return; // skip if no main variant

      const frameSystemId = $it.attr('data-frame-system-id') || '';
      const price = n($it.attr('data-price'));
      const comp = n($it.attr('data-compare'));

      const mrk_main_variant = n($it.attr('data-main-variant'));

      // variants prepared by updateItem (frame, framing-service, etc.)
      const prepared = Array.isArray($it.data('variants')) ? [...$it.data('variants')] : [];

      // Optionally add framing service from attribute if present & not already in list
      const fsId = $it.attr('data-framing-service-id');
      if (fsId && !prepared.some(v => String(v.id) === String(fsId))) {
        prepared.push({ id: fsId, parent_id: mainId });
      }

      // Flatten lines: main line first (can carry properties[_frame_id]), then children
      const lines = [
        { id: mainId, parent_id: '', _frame_id: frameSystemId, _main_variant: mrk_main_variant },
        ...prepared.map(v => ({
          id: v.id,
          parent_id: v.parent_id || mainId
        }))
      ];

      // Emit inputs: first overall line => name="id", rest => items[idx][…]
      lines.forEach(line => {
        if (idx === -1) {
          // first line in the whole form
          inputs += `<input name="id" type="hidden" value="${line.id || ''}">\n`;
          if (line._frame_id) {
            inputs += `<input name="properties[_frame_id]" type="hidden" value="${line._frame_id}">\n`;
          }
          if (line._main_variant) {
            inputs += `<input name="properties[_main_variant]" type="hidden" value="${line._main_variant}">\n`;
          }
        } else {
          inputs += `<input name="items[${idx}][id]" type="hidden" value="${line.id || ''}">\n`;
          if (line.parent_id) {
            inputs += `<input name="items[${idx}][parent_id]" type="hidden" value="${line.parent_id}">\n`;
          }
          if (line._frame_id) {
            inputs += `<input name="items[${idx}][properties[_frame_id]]" type="hidden" value="${line._frame_id}">\n`;
          }
          if (line._main_variant) {
            inputs += `<input name="items[${idx}][properties[_main_variant]]" type="hidden" value="${line._main_variant}">\n`;
          }
        }
        idx++;
      });

      total += price;
      tComp += comp;
    });

    $inputsBox.html(inputs);
    $('.mrk-main-price').text(Shopify.formatMoney(total));
    $('.mrk-main-compare-price').text(tComp ? Shopify.formatMoney(tComp) : '');
    $('.mrk-discount-percent').text(off(total, tComp));
    // $('.mrk-bundle-main-btn').prop('disabled', html === '');
    var selectedFrame = $('frame-variant-picker input:checked:eq(1)');
    var frameName = $(selectedFrame).val()?.toLowerCase();
    $('media-gallery .mrk-featured-product-frame-wrapper .mrk-frame-image-item').removeClass('mrk-active-gallery-frame').hide();
    $(`media-gallery .mrk-frame-image-item[color="${frameName}"]`).addClass('mrk-active-gallery-frame').show();
    $(`.mrk-tab-trigger[data-content="${frameName}"]`).click();
    mrkUpdateFrameTotal()
  }

  $(document).on('change', '.mrk-gallery-wall-item .mrk-variant-option, .mrk-gallery-wall-item .mrk-option-option', function () {
    const $item = $(this).closest('.mrk-gallery-wall-item');
    updateItem($item);
    var selectedOption = $item.find('.mrk-variant-option option:selected').attr('title');
    // updateFrames(selectedOption);
    rebuild();
  });

  $(document).on('change', 'frame-variant-picker, [name="framing-service"]', function () {
    $('.mrk-gallery-wall-item').each(function(){ updateItem($(this)); });
    rebuild();
  });

  // initial pass
  $(function(){
    window.mrkFrameData = window.mrkFrameData || [];
    $('.mrk-gallery-wall-item').each(function(){ updateItem($(this)); });
    var selectedOption = $('.mrk-gallery-wall-item .mrk-variant-option option:selected').attr('title');
    // updateFrames(selectedOption);
    rebuild();
  });
})(jQuery);